import { useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import usePermissions from '../../hooks/usePermissions';
import { groupNavItems } from '../../utils/permissions';

const AdminStats = ({ stats, showOrgMetrics = true }) => {
  const navigate = useNavigate();
  const { navItems, role } = usePermissions();

  const groups = useMemo(() => groupNavItems(navItems), [navItems]);

  const metrics = [
    { label: 'Students', value: stats.students || 0 },
    { label: 'Trainers', value: stats.trainers || 0 },
    { label: 'Courses', value: stats.courses || 0 },
    { label: 'Users', value: stats.totalUsers || 0 },
    { label: 'Recruiters', value: stats.recruiter || 0 },
  ];

  return (
    <>
      {showOrgMetrics ? (
        <div className="staff-metrics">
          {metrics.map((m) => (
            <div key={m.label} className="staff-metric">
              <span className="staff-metric-label">{m.label}</span>
              <span className="staff-metric-value">{m.value}</span>
            </div>
          ))}
        </div>
      ) : null}

      {navItems.length === 0 && role !== 'admin' ? (
        <p className="staff-empty">No feature access assigned. Contact an administrator.</p>
      ) : null}

      {groups.map(({ group, items }) => (
        <section key={group} className="staff-section">
          <div className="staff-section-head">
            <h3>{group}</h3>
          </div>
          <div className="staff-nav-grid">
            {items.map((item) => (
              <button
                key={item.path}
                type="button"
                className="staff-nav-tile"
                onClick={() => navigate(item.path)}
              >
                <span className="staff-nav-tile-title">{item.label}</span>
                {item.description ? (
                  <span className="staff-nav-tile-desc">{item.description}</span>
                ) : null}
              </button>
            ))}
          </div>
        </section>
      ))}
    </>
  );
};

export default AdminStats;
